import { Profile as AccountsProfile } from "./accounts/Profile";
import { CompletePasswordReset as AuthCompletePasswordReset } from "./auth/CompletePasswordReset";
import { RequestPasswordReset as AuthRequestPasswordReset } from "./auth/RequestPasswordReset";
import { SignIn as AuthSignIn } from "./auth/SignIn";
import { List as BrandsList } from "./brands/List";
import { PressKit as BrandsPressKit } from "./brands/PressKit";
import { Show as ItemsShow } from "./items/Show";
import { Show as LinesShow } from "./lines/Show";
import { Cart as OrdersCart } from "./orders/Cart";
import { List as OrdersList } from "./orders/List";
import { CartConfirmed as OrdersCartConfirmed } from "./orders/CartConfirmed";
import { Show as SeasonsShow } from "./seasons/Show";

const frames = {
  AuthCompletePasswordReset,
  AuthRequestPasswordReset,
  AuthSignIn,

  BrandsList,
  BrandsPressKit,
  SeasonsShow,
  LinesShow,
  ItemsShow,
  OrdersList,
  OrdersCart,
  OrdersCartConfirmed,
  AccountsProfile,
};

export default frames;
